import {
  jb_timer_css_default
} from "./chunk.6VZH2HJI.js";
import {
  e
} from "./chunk.3XLWIJBS.js";
import {
  reset_css_default
} from "./chunk.YAATWOBE.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  n,
  r
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-timer/jb-timer.ts
var JbTimer = class extends i {
  constructor() {
    super(...arguments);
    this.align = "left";
  }
  update(changedProperties) {
    super.update(changedProperties);
    if (changedProperties.has("seconds")) {
      this._displayMinutes = Math.floor(Math.abs(this.seconds) / 60).toString().padStart(2, "0");
      this._displaySeconds = Math.round(Math.abs(this.seconds) % 60).toString().padStart(2, "0");
    }
  }
  render() {
    return b`<div class=${e({ "right-aligned": this.align === "right" })}>
      <span>${this.seconds < 0 ? "-" : ""}${this._displayMinutes}:${this._displaySeconds}</span>
    </div>`;
  }
};
JbTimer.styles = [reset_css_default, jb_timer_css_default];
__decorateClass([
  n()
], JbTimer.prototype, "align", 2);
__decorateClass([
  n({ type: Number })
], JbTimer.prototype, "seconds", 2);
__decorateClass([
  r()
], JbTimer.prototype, "_displayMinutes", 2);
__decorateClass([
  r()
], JbTimer.prototype, "_displaySeconds", 2);
JbTimer = __decorateClass([
  customElement("jb-timer")
], JbTimer);

export {
  JbTimer
};
